import { Empty } from "antd";
import DepositsCard from "../deposits";
import { useTranslation } from "react-i18next";


export default function DepositListItem({ dataSource = [] }) {
  const { t } = useTranslation();
  return (
    <>
      {dataSource.length === 0 ? (
        <Empty description={t("common.no_records_found", {
              defaultValue: "No Records Found",
            })} />
      ) : (
        <div>
          {dataSource.map((option, index) => (
            <DepositsCard record={option} />
          ))}
        </div>
      )}
    </>
  );
}
